import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { Select, Option } from 'barnyard/components';
import { suppliersFetch } from '../actions';
import { useSuppliers } from '~/app/corporate/core/selectors';


const SupplierSelect = (props) => {
  const {
    include_all,
    include_any,
    eligibleSuppliers,
    ...other
  } = props;
  const allSuppliers = useSuppliers();
  const choices = useMemo(() => eligibleSuppliers || allSuppliers, [eligibleSuppliers, allSuppliers]);
  const dispatch = useDispatch();
  useEffect(() => {
    if (_.isEmpty(choices)) {
      dispatch(suppliersFetch());
    }
  }, [dispatch, choices]);

  return (
    <Select
      optionFilterProp='name'
      {...other}
    >
      {include_all && <Option value='all'>All Suppliers</Option>}
      {include_any && <Option value='any'>Any Supplier</Option>}
      {_.map(choices, supplier => (
        <Option
          value={supplier.id}
          key={supplier.id}
          name={supplier.short_name}
        >
          {supplier.short_name}
        </Option>
      ))}
    </Select>
  );
};

SupplierSelect.propTypes = {
  eligibleSuppliers: PropTypes.object,
  include_all: PropTypes.bool,
  include_any: PropTypes.bool,
};

export default SupplierSelect;
